import React from "react";

const About = () => {
  return (
    <div className="about">
      {/* About Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title animate-fade-up">About Laiger</h1>
          <p className="page-subtitle animate-fade-up">
            Crafting premium clothing since 2010
          </p>
        </div>
        <div className="hero-overlay"></div>
        <div
          className="hero-image"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1490481651871-ab68de25d43d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')",
          }}
        ></div>
      </section>

      <section className="about-content section-padding">
        <div className="container">
          <div className="about-section">
            <div className="about-text animate-fade-left">
              <h2>Our Story</h2>
              <p>
                Founded in 2010, Laiger began as a small workshop dedicated to
                creating high-quality jeans for local markets. What started with
                a single product line has grown into a comprehensive clothing
                manufacturer specializing in premium denim, shirts, t-shirts,
                sweaters, and jackets.
              </p>
              <p>
                Our name, Laiger, comes from the old English word meaning "to
                fabricate with care" – a principle that guides every aspect of
                our work.
              </p>
            </div>
            <div className="about-image animate-fade-right">
              <img
                src="https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
                alt="Laiger Workshop"
              />
            </div>
          </div>

          <div className="about-section reverse">
            <div className="about-text animate-fade-right">
              <h2>Our Mission</h2>
              <p>
                At Laiger, our mission is to bridge the gap between exceptional
                quality and responsible manufacturing. We believe that premium
                clothing shouldn't come at the expense of our planet or the
                people who make it.
              </p>
              <p>
                We're committed to creating garments that last longer, fit
                better, and make our customers feel confident while minimizing
                our environmental footprint.
              </p>
            </div>
            <div className="about-image animate-fade-left">
              <img
                src="https://images.unsplash.com/photo-1523381210434-271e8be1f52b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
                alt="Sustainable Materials"
              />
            </div>
          </div>

          <div className="values-section">
            <div className="section-header">
              <h2>Our Values</h2>
              <p>The principles that guide everything we do</p>
            </div>
            <div className="values-grid">
              {[
                {
                  icon: "🎯",
                  title: "Quality First",
                  desc: "We never compromise on materials or craftsmanship.",
                },
                {
                  icon: "🌱",
                  title: "Sustainability",
                  desc: "Responsible sourcing and eco-friendly processes.",
                },
                {
                  icon: "👕",
                  title: "Perfect Fit",
                  desc: "Attention to detail in every cut and stitch.",
                },
                {
                  icon: "🤝",
                  title: "Ethical Practices",
                  desc: "Fair wages and safe working conditions for all.",
                },
                {
                  icon: "💡",
                  title: "Innovation",
                  desc: "Constantly improving our designs and processes.",
                },
                {
                  icon: "❤️",
                  title: "Customer Focus",
                  desc: "Creating pieces that our customers will love for years.",
                },
              ].map((value, index) => (
                <div key={index} className="value-card animate-scale">
                  <div className="value-icon">{value.icon}</div>
                  <h4>{value.title}</h4>
                  <p>{value.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
